import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PathologyListRes;
export const PathologyListTodo = createAsyncThunk('PathologyList', async (data) => {

    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'superadmin/company_master',
            params: {
                    "uid":localStorage.getItem('user_id')
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') },

        })
        return PathologyListRes = res.data

    } catch (error) {
        return PathologyListRes = error.response.data
    }
});

const PathologyListSlice = createSlice({
    name: 'PathologyList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(PathologyListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(PathologyListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default PathologyListSlice.reducer; 